import { PropsWithChildren, ReactElement, useState } from 'react';
import { AccordionBody, AccordionHeader, AccordionItem, UncontrolledAccordion } from 'reactstrap';

interface IServicesPanelProps {
    title: string;
};

export default function ServicesPanel(props: PropsWithChildren<IServicesPanelProps>) {
    return (
        <div className='services-panel p-2 card'>
            <div className='card-body'>
                <h3 className='card-title'>{props.title}</h3>
                <div className='d-flex flex-row card-text'>
                    {props.children}
                </div>
            </div>
        </div>
    );
}
